import React, { useEffect, useState } from "react";
import { updateIntegration } from "../../../../apis/workspace/integrations";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { useMutation } from "react-query";
import { Button } from "../../../ui/button";
import { Switch } from "../../../ui/switch";
import Image from "../../../Tags/Image";

export default function GeneralInfo({
  onSuccess,
  onError,
  currentIntegration = {},
  activeWorkspace,
  isSubmitting,
  isLoading,
}) {
  const { crmConfigId, crmKey } = useParams();
  // update config name
  const [connectionName, setConnectionName] = useState("");

  // advanced person search toggle
  const [advancedPersonSearch, setAdvancedPersonSearch] = useState(false);
  const updateToggleFn = useMutation("update_toggle", updateIntegration, {
    onSuccess(data, variables, context) {
      if (data?.message) {
        toast.success(data.message);
      } else if (data?.status === 200 || (!data?.status && data)) {
        toast.success("Setting updated successfully");
      }
    },
    onError(error) {
      const errorMessage = error?.response?.data?.message || error?.message || "Failed to update setting";
      toast.error(errorMessage);
    },
  });

  // Handle advanced person search toggle change
  const handleAdvancedPersonSearchChange = (checked) => {
    const previousState = advancedPersonSearch;
    setAdvancedPersonSearch(checked);
    updateToggleFn.mutate({
      data: { advanced_person_search: checked },
      configId: crmConfigId,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    }, {
      onError: () => {
        // Revert state on error
        setAdvancedPersonSearch(previousState);
      }
    });
  };

  const updateIntegrationFn = useMutation("install_integration", updateIntegration, {
    onSuccess(data, variables, context) {
      toast.success(data?.message);
      onSuccess();
      isLoading(false);
    },
    onError(error) {
      onError();
      isLoading(false);
    },
  });
  const handleUpdateIntegrationName = () => {
    isLoading(true);
    if (updateIntegrationFn.isLoading) {
      return;
    }
    updateIntegrationFn.mutate({
      data: { name: connectionName },
      configId: crmConfigId,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };
  useEffect(() => {
    if (isSubmitting) {
      handleUpdateIntegrationName();
    }
  }, [isSubmitting]);

  useEffect(() => {
    if (currentIntegration?.advanced_person_search !== undefined) {
      setAdvancedPersonSearch(currentIntegration.advanced_person_search);
    }
  }, [currentIntegration]);

  const supportsAdvancedPersonSearch = () => {
    const integrationKey = currentIntegration?.integration?.key;
    return integrationKey === 'salesforce' || integrationKey === 'zoho';
  };

  return (
    <>
      <div className="">
        <p className="text-sm text-gray-900 font-semibold mb-2">Connection name</p>
        <input
          onChange={(e) => {
            setConnectionName(e.target.value);
          }}
          defaultValue={currentIntegration?.name}
          placeholder="Connection name"
          className="h-11 px-[14px] py-[10px] text-sm w-4/12 rounded-[--radius] border border-input bg-background text-text-900 "
        />
      </div>

      <div className="border-y my-6 py-6">
        <p className="text-sm text-gray-900 font-semibold mb-2 capitalize">{crmKey} URL</p>
        <p className="text-sm text-gray-600 font-normal mt-1">{currentIntegration?.instance_url}</p>
      </div>
      <div className="border-b pb-6">
        <p className="text-sm text-gray-900 font-semibold mb-2">Connected {crmKey} User</p>
        <p className="text-sm text-gray-600 font-normal mt-1">
          {currentIntegration?.crm_user_name} ({currentIntegration?.crm_user_email})
        </p>
      </div>
      
      {supportsAdvancedPersonSearch() && (
        <div className="border-b pb-6 py-6">
          <div className="flex items-center gap-3 mb-2">
            <Switch
              checked={advancedPersonSearch}
              onCheckedChange={handleAdvancedPersonSearchChange}
              disabled={updateToggleFn.isLoading}
            />
            <p className="text-sm text-gray-900 font-semibold">Advanced Person Search</p>
          </div>
          <p className="text-sm text-gray-600 font-normal">
          CRM search for people will also use data on the linked company object to improve search results. This might increase the search response time.
          </p>
        </div>
      )}
      
      <div className="py-6">
        <p className="text-sm text-gray-900 font-semibold mb-2">Authentication</p>
        <Button
          variant="outline"
          className="inline-flex items-center space-x-2"
          onClick={() => {
            window.location.href = `${process.env.REACT_APP_API_BASE_URL}/workspace-settings/integrations/${crmKey}/reauthorize/${crmConfigId}`;
          }}
        >
          <Image src="/images/icons/untitledui/re-auth.svg" />
          <span>Re-authentication</span>
        </Button>
      </div>
    </>
  );
}
